export const handleSectionNavigation = (
  e,
  id,
  navigate,
  scrollToSection,
  onNavigate
) => {
  e.preventDefault();

  if (onNavigate) {
    onNavigate();
  }

  const sectionExists = document.getElementById(id);

  if (sectionExists) {
    scrollToSection(id, true);
    return;
  }

  navigate('/');
};